/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CrefoChangeExtendedMonitoringResponseDto } from '../../models/crefo-change-extended-monitoring-response-dto';

export interface CancelExtendedMonitoring$Params {
  referenceNumber: number;
  customerGUID: string;
}

export function cancelExtendedMonitoring(http: HttpClient, rootUrl: string, params: CancelExtendedMonitoring$Params, context?: HttpContext): Observable<StrictHttpResponse<CrefoChangeExtendedMonitoringResponseDto>> {
  const rb = new RequestBuilder(rootUrl, cancelExtendedMonitoring.PATH, 'post');
  if (params) {
    rb.query('referenceNumber', params.referenceNumber, {});
    rb.query('customerGUID', params.customerGUID, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<CrefoChangeExtendedMonitoringResponseDto>;
    })
  );
}

cancelExtendedMonitoring.PATH = '/crefo/monitoring/extended/cancel';
